import React from "react";
import { withTranslation } from "react-i18next";
import EnquiryList from "../../../../Enquiry/EnquiryList";
import { OuterWrapperBackground, ButtonWrapper } from "../Site/Site.styled";

const Enquiry = (props) => {
  const { t, siteData } = props;

  return (
    <>
      <OuterWrapperBackground>
        <EnquiryList
          entityType="site"
          entityId={siteData.id}
          page="createSite"
          platformCountryId={siteData?.platformCountry?.id}
          headerNotRequired
          columnList={[
            "ID",
            "CONTACT_COMPANY",
            "CONTACT_NAME",
            "CONTACT_FUNCTION",
            "CONTACT_TYPE",
            "CONTACT_COMMUNICATION",
            "ACTIONS",
          ]}
        />
      </OuterWrapperBackground>
    </>
  );
};

export default withTranslation()(Enquiry);
